<template>
  <div class="pt-2" style="background: #f0f0f0;font-family: PingFangSC-Medium, PingFang SC;">
    <v-card flat>
      <v-form style="margin-bottom: 20px;padding: 5px;">
        <div style="width: 80%;margin: 20px;">
          <el-row>
            <el-button type="primary" @click="submitRecordForm">提交</el-button>
            <el-button type="primary" v-if="item != null" @click="dialogAuditVisible == true">审批</el-button>
            <el-button type="primary" v-if="item != null" @click="activeSure">激活</el-button>
            <el-button type="error" @click="back">返回</el-button>
          </el-row>

        </div>
        <div class="information">
          <div class="inforTitle">卖券单信息</div>
          <div style="margin-top: 15px;">
            <el-row>
              <el-col :span="8">
                <div>门店</div>
                <div class="color-h">{{ couponInfo.shopName }}</div>
              </el-col>
              <el-col :span="8">
                <div>卖券单号 <span style="margin-left: 10px;color: #2B9AEA;cursor: pointer;font-family: fangsong" @click="aaa">关联卖券单</span></div>
                <div class="color-h">{{ couponInfo.handleNo }}</div>
              </el-col>
              <el-col :span="8">
                <div>卖券单类型</div>
                <div class="color-h">
                  <span v-if="couponInfo.handleType == 1">线上</span>
                  <span v-else-if="couponInfo.handleType == 2">存款售卡</span>
                  <span v-else-if="couponInfo.handleType == 3">售预开卡</span>
                  <span v-else-if="couponInfo.handleType == 4">普通售卡</span>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <div>团购金额</div>
                <div class="color-h">{{ couponInfo.groupAmount }}</div>
              </el-col>
              <el-col :span="8">
                <div>团购数量</div>
                <div class="color-h">{{ couponInfo.groupNum }}</div>
              </el-col>
              <el-col :span="8">
                <div>返券比例&nbsp;<span style="color: red;">(0.01% - 10%)</span></div>
                <div class="color-h"><el-input v-model="couponInfo.sendCouponRatio" style="width: 98%;"></el-input></div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <div>客户名称</div>
                <div class="color-h">{{ couponInfo.customerName }}</div>
              </el-col>
              <el-col :span="8">
                <div>代办员名称</div>
                <div class="color-h">{{couponInfo.agentName}}</div>
              </el-col>
              <el-col :span="8">
                <div>代办员手机号</div>
                <div class="color-h">{{ couponInfo.agentMobile }}</div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <div>客户专员</div>
                <div class="color-h">{{couponInfo.customerSpecialist}}</div>
              </el-col>
              <el-col :span="8">
                <div><span style="color: red;">*</span>使用区域</div>
                <div class="color-h"><el-input v-model="couponInfo.area" maxlength="8" show-word-limit style="width: 98%;"></el-input></div>
              </el-col>
              <el-col :span="8">
                <div><span style="color: red;">*</span>使用说明</div>
                <div class="color-h"><el-input v-model="couponInfo.useInfo" maxlength="27" show-word-limit style="width: 98%;"></el-input></div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <div><span style="color: red;">*</span>券标题</div>
                <div class="color-h"><el-input v-model="couponInfo.title" maxlength="15" show-word-limit style="width: 98%;"></el-input></div>
              </el-col>
            </el-row>
          </div>
        </div>
        <div style="height: 20px;background: #f0f0f0"></div>
        <div class="information">
          <div class="inforTitle">赠券定义 <span style="color: red;">(注意：首先关联卖券单，然后选择开始时间、结束时间，然后选择收券规则，最后新增赠券。 顺序不可乱 )</span></div>
          <div style="margin-top: 15px;">
            <el-row>
              <el-col :span="8">
                <div>开始时间</div>
                <div class="color-h">
                  <el-date-picker
                      type="datetime"
                      v-model="watchInfo.startTime"
                      style="border-color: rgba(0,0,0,0.38)"
                  ></el-date-picker>
                </div>
              </el-col>
              <el-col :span="8">
                <div>结束时间</div>
                <div class="color-h">
                  <el-date-picker
                      type="datetime"
                      v-model="watchInfo.endTime"
                      style="border-color: rgba(0,0,0,0.38)"
                  ></el-date-picker>
                </div>
              </el-col>
              <el-col :span="8">
                <div>收券规则</div>
                <div class="color-h">
                  <el-select v-model="zcInfo.rule" placeholder="请选择">
                    <el-option
                        v-for="item in optionsRule"
                        :key="item.couponName"
                        :label="item.sheetId + '-' + item.popName"
                        :value="item.sheetId + ',' + item.popName + ',' + item.couponType + ',' + item.couponName">
                    </el-option>
                  </el-select>
                </div>
              </el-col>
            </el-row>
            <el-row style="margin-top: 5px;">
              <el-col :span="8">
                <div>返券总额</div>
                <div class="color-h">{{ zcInfo.amount }}</div>
              </el-col>
              <el-col :span="8">
                <div>返券张数</div>
                <div class="color-h">{{ zcInfo.num }}</div>
              </el-col>
            </el-row>
            <div style="margin: 10px 0px;">
              <table-merge  :table-data="tableData" :table-field="tableFieldCoupon" :table-config="tableConfigCoupon" :page-info="pageInfoCoupon">
                <div slot="amount" slot-scope="{ item }">
                  <el-input v-model="item.amount" placeholder="请输入"></el-input>
                </div>
                <div slot="num" slot-scope="{ item }">
                  <el-input v-model="item.num" placeholder="请输入"></el-input>
                </div>
                <div slot="opera" slot-scope="{ item }">
                  <el-button type="warning" @click="delSendCoupon(item)">删除</el-button>
                </div>
              </table-merge>
              <div class="addSendCoupon" @click="addSendCoupon">
                <i class="el-icon-plus"></i>新增赠券
              </div>
            </div>
          </div>
        </div>
        <div style="height: 20px;background: #f0f0f0;"></div>
        <div class="information">
          <div class="inforTitle">制单信息</div>
          <div style="margin-top: 15px;">
            <el-row>
              <el-col :span="8">
                <div>制单人</div>
                <div class="color-h" v-if="zdInfo.zdUser">{{ zdInfo.zdUser }}</div>
                <div class="color-h" v-else>{{ session.userName }}</div>
              </el-col>
              <el-col :span="8">
                <div>制单时间</div>
                <div class="color-h">{{ zdInfo.zdTime }}</div>
              </el-col>
            </el-row>
          </div>
        </div>
      </v-form>
    </v-card>

    <el-dialog
        title="提示"
        :visible.sync="dialogCouponVisible"
        width="60%"
        style="height: 600px;"
        :before-close="handleClose">
      <div style="padding: 10px;">
        <el-form ref="formIn" :inline="true" :model="formIn" label-width="70px">
          <el-row>
            <el-col :span="8">
              <el-form-item label="门店">
                <el-select v-model="formIn.shopId" placeholder="请选择门店">
                  <el-option
                      v-for="item in optionStore"
                      :key="item.shopId"
                      :label="item.shopName"
                      :value="item.shopId">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="类型">
                <el-select v-model="formIn.handleType" placeholder="卖券单类型">
                  <el-option label="线上" value="1"></el-option>
                  <el-option label="线下" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="单号">
                <el-input v-model="formIn.handleNo" placeholder="卖券单号"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10">
              <el-form-item label="创建时间">
                <el-date-picker
                    type="date"
                    v-model="formIn.createTime"
                    value-format="yyyy-MM-dd"
                    style="border-color: rgba(0,0,0,0.38)"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">查询</el-button>
            </el-form-item>
          </el-row>

        </el-form>
        <div style="margin-top: 10px">
          <table-merge v-bind:table-data="tableDataIn" v-bind:table-field="tableField" v-bind:table-config="tableConfig" :page-info="pageInfo">
            <div slot="opera" slot-scope="{ item }">
              <el-button size="small" type="primary" @click="searchIn(item)">选择</el-button>
            </div>
          </table-merge>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogCouponVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogCouponVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import StoreApi from "../../../../api/pd/common/StoreApi";
import GrouponApi from "../../../../api/sm/market/groupon/grouponApi"
import tableMerge from "../../../../components/elTable/tableMerge"
import { default as commonIn } from '@/util/common'
export default {
  name: "grouponCreate",
  components: {
    tableMerge: tableMerge
  },
  props: {
    page: {
      type: Object,
      default: null
    },
    item: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      dialogAuditVisible: false,
      dialogActiveVisible: false,
      tableDataIn: [],
      tableConfig: {
        isCheckBox: 0,
        isOpera: 1
      },
      tableField: [
        {
          columnCode: 'shopName',
          columnName: '门店名称',
          isSlot: 0,
          width: 150
        },
        {
          columnCode: 'handleNo',
          columnName: '券编号',
          isSlot: 0,
          width: 150
        },
        {
          columnCode: 'groupAmount',
          columnName: '券面值',
          isSlot: 0,
          width: 100
        },
        {
          columnCode: 'groupNum',
          columnName: '券数量',
          isSlot: 0,
          width: 100
        },
        {
          columnCode: 'customerName',
          columnName: '客户名称',
          isSlot: 0,
          width: 200
        }
      ],
      tableFieldCoupon: [
        {columnCode: 'Id',columnName: '编号', isSlot: 0, width: 100, isAutoAdd: 1},
        {columnCode: 'couponType',columnName: '收券类型', isSlot: 0, width: 200},
        {columnCode: 'thresholdAmount',columnName: '门槛金额', isSlot: 0, width: 100},
        {columnCode: 'amount',columnName: '面值金额', isSlot: 1, width: 150},
        {columnCode: 'num',columnName: '数量', isSlot: 1, width: 150},
        {columnCode: 'allAmount',columnName: '金额', isSlot: 0, width: 120}
      ],
      pageInfo: {
        pageSize: ''
      },
      tableConfigCoupon: {
        isCheckBox: 0,
        isOpera: 1
      },
      pageInfoCoupon: {
        pageSize: ''
      },
      couponInfo: {
        shopId: '',
        shopName: '',
        handleNo: '',
        handleType: '',
        groupAmount: 0,
        groupNum: 0,
        sendCouponRatio: '',
        customerName: '',
        agentName: '',
        agentMobile: '',
        customerSpecialist: '',
        area: '',
        useInfo: '',
        title: ''
      },
      dialogCouponVisible: false,
      zcInfo: {
        amount: 0,
        num: 0,
        rule: ''
      },
      watchInfo: {
        startTime: '',
        endTime: ''
      },
      zdInfo: {
        zdUser: '',
        zdTime: commonIn.timeFormatSeconds(new Date()),
      },
      tableData: [

      ],
      formIn: {
        shopId: '',
        createTime: '',
        handleType: '',
        handleNo: ''
      },
      optionStore: [],
      optionsRule: [
        {label: '通用', value: 1}
      ],
      number: 1,
      couponType: '提货券',
      ruleInfo: []
    }
  },
  created() {

  },
  mounted() {
    this.getStore()
    console.log(this.item)
    if (this.item != null && this.item.id) {
      this.getRecordDetail(this.item.id)
    }
  },
  computed: {
    session(){
      let session= this.$store.getters['app/getSession'];
      if(!session)
        session={userName:'',mobile:''};
      return session;
    }
  },
  watch: {
    watchInfo: {
      handler(newVal, oldVal) {
        if (newVal.startTime != '' && newVal.endTime != '') {
          if (this.couponInfo.shopId == '') {
            alert('请先关联卖券单')
            return false
          }
          this.getRuleList(newVal.startTime, newVal.endTime)
        }
      },
      immediate: true,
      deep: true
    },
    pageInfo: {
      handler(newVal, oldVal) {
        console.log(newVal)
        console.log(oldVal)
      },
      immediate: true,
      deep: true
    },
    tableData: {
      handler(newVal, oldVal) {
        this.zcInfo.amount = 0
        this.zcInfo.num = 0
        newVal.map(item => {
          if (item.amount != '' && item.num != '') {
            item.amount = parseFloat(item.amount)
            item.num = parseInt(item.num)
            item.allAmount = (item.amount * item.num).toFixed(2)
            this.zcInfo.amount += parseFloat(item.allAmount)
            this.zcInfo.num += parseInt(item.num)
            let Amount = parseInt(this.couponInfo.groupAmount) * parseFloat(this.couponInfo.sendCouponRatio) / 100
            console.log(Amount)
            console.log(this.zcInfo.amount)
            if (parseFloat(this.zcInfo.amount) > Amount) {
              alert('返券金额不能大于赠券总额!')
              return false
            }
          }
        })
      },
      deep: true
    },
    zcInfo: {
      handler(newVal, oldVal) {
        if (newVal.rule != '') {
          let arr = newVal.rule
          let arrIn = arr.split(",")
          if (arrIn.length == 4) {
            console.log(arrIn)
            this.ruleInfo = arrIn
            this.couponType = arrIn[3]
          } else {
            this.couponType = arrIn[0]
          }

        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 获取记录详情
    getRecordDetail(recordId) {
      let that = this

      GrouponApi.getDetail(recordId).then(res => {
        console.log(res)
        res = res.data
        if (res.code == 200) {
          that.couponInfo = res.data
          that.zdInfo.zdUser = res.data.createName
          that.zcInfo.createTime = commonIn.timeFormatSeconds(that.zcInfo.createTime)
          that.zcInfo.amount = res.data.sendCouponAmount
          that.zcInfo.num = res.data.sendCouponNum
          that.tableData = res.data.templateList

          let arrIn = that.tableData[0]
          that.couponType = arrIn.sendCouponTypeName
          that.zcInfo.rule = arrIn.sendCouponRuleId + '-' + arrIn.sendCouponRuleName
          that.watchInfo.startTime = arrIn.startDate
          that.watchInfo.endTime = arrIn.endDate
          that.ruleInfo = [
            arrIn.sendCouponRuleId, arrIn.sendCouponRuleName, arrIn.sendCouponType, arrIn.sendCouponTypeName
          ]
          that.tableData.map((item, index) => {
            item.Id = index + 1
            item.couponType = arrIn.sendCouponTypeName
          })
          that.number = that.tableData.length + 1
        } else {
          alert(res.msg)
        }
      }).catch(error => {
        console.log(error)
      })
    },
    // 提交定义单
    submitRecordForm() {
      let that = this
      if (this.couponInfo.area == '' || this.couponInfo.useInfo == '') {
        alert('请填写使用区域和使用说明!')
        return false
      }
      if (this.tableData.length == 0) {
        alert('定义单数据不全，不可提交')
        return false
      }
      let Amount = parseInt(this.couponInfo.groupAmount) * parseFloat(this.couponInfo.sendCouponRatio) / 100
      if (Amount < parseFloat(this.zcInfo.amount)) {
        alert('返券总额不能大于赠券金额!')
        return false
      }



      let params = {
        "shopId": this.couponInfo.shopId,
        "shopName": this.couponInfo.shopName,
        "handleNo": this.couponInfo.handleNo,
        "handleType": this.couponInfo.handleType,
        "groupAmount": this.couponInfo.groupAmount,
        "groupNum": this.couponInfo.groupNum,
        "sendCouponRatio": this.couponInfo.sendCouponRatio,
        "sendCouponAmount": this.zcInfo.amount,
        "sendCouponNum": this.zcInfo.num,
        "customerName": this.couponInfo.customerName,
        "agentName": this.couponInfo.agentName,
        "agentMobile": this.couponInfo.agentMobile,
        "customerSpecialist": this.couponInfo.customerSpecialist,
        "area": this.couponInfo.area,
        "useInfo": this.couponInfo.useInfo,
        "title": this.couponInfo.title,
        "templateList": this.tableData
      }
      if (this.item != null) {
        params.id = this.item.id
      }

      GrouponApi.addRecord(params).then(res => {
        console.log(res)
        res = res.data
        if (res.code == 200) {
          alert('操作成功！')
          that.back()
        } else {
          alert(res.msg)
        }
      }).catch(error => {
        console.log(error)
      })
    },
    // 新增赠券
    addSendCoupon() {
        if (this.zcInfo.rule == '') {
          alert('请选择券规则后再进行此操作!')
          return false
        }
        let info = {
          Id: this.number,
          couponType: this.couponType,
          thresholdAmount: 0.01,
          amount: '',
          num: '',
          allAmount: 0,
          sendCouponType: this.ruleInfo[2],
          sendCouponTypeName: this.ruleInfo[3],
          sendCouponRuleId: this.ruleInfo[0],
          sendCouponRuleName: this.ruleInfo[1],
          startDate: commonIn.timeFormatSeconds(this.watchInfo.startTime),
          endDate: commonIn.timeFormatSeconds(this.watchInfo.endTime)
        }

        this.tableData.push(info)
        this.number++
        console.log(this.tableData)
    },
    // 删除赠券
    delSendCoupon(item) {
      let indexIn = ''
      this.tableData.map((itemIn, index) => {
        if (itemIn.Id == item.Id) {
          indexIn = index
        }
      })
      this.tableData.splice(indexIn, 1)
    },
    getMqdInfo() {

    },
    aaa() {
      this.dialogCouponVisible = true
    },
    getChildClick(data) {
      console.log(data)
    },
    searchIn(item) {
      this.couponInfo = item
      this.dialogCouponVisible = false
    },
    onSubmit() {
      let that = this
      if (this.formIn.shopId == '' || this.formIn.handleType == '') {
        alert('请选择门店和卖券单类型')
      }
      let params = {
        shopId: this.formIn.shopId,
        type: this.formIn.handleType,
        handleNo: this.formIn.handleNo
      }

      GrouponApi.getGroupBuyInfo(params).then(res => {
        console.log(res)
        res = res.data
        if (res.code == 200) {
          that.tableDataIn = res.data
        }
      })
    },
    getRuleList(startTime, endTime) {
      let that = this
      let params = {
        shopId: this.couponInfo.shopId,
        popName: '提货券',
        startDate: commonIn.timeFormatSeconds(startTime),
        endDate: commonIn.timeFormatSeconds(endTime)
      }

      GrouponApi.getRule(params).then(res => {
        console.log(res)
        res = res.data
        if (res.code == 200) {
          that.optionsRule = res.data
        } else {
          alert(res.msg)
        }
      }).catch(error => {
        console.log(error)
      })
    },
    delItem(item) {
      console.log(item)
    },
    handleClose() {
      this.dialogCouponVisible = false
    },
    // 获取门店列表
    getStore() {
      let that = this
      StoreApi.queryStoreList().then(res => {
        console.log(res)
        res = res.data
        if (res.code == 200) {
          that.optionStore = res.data.shopPriviledges
          console.log(that.optionStore)
        } else {
          that.$message.error(res.msg)
        }
      }).catch(error => {
        console.log(error)
        that.$message.warning('系统错误！请稍后尝试')
      })
    },
    // 返回
    back() {
      this.$emit("back", {formStatus: 'list'})
    },
  }
}
</script>

<style scoped>
  .color-h {
    color: #a5a8ad !important;
    font-size: 15px;
    font-family: 'Microsoft YaHei UI', 'Microsoft YaHei', DengXian, SimSun, 'Segoe UI', Tahoma, Helvetica, sans-serif;
    height: 40px;
  }

  .information {
    width: 80%;
    margin: 20px;
    background: #fff;
    border: 1px solid #c0c0c0;
    border-radius: 20px;
    box-sizing: border-box;
    font-size: 16px;
    line-height: 35px;
    padding: 10px;
    box-shadow: 1px 4px 10px 0px #c0c0c0;
  }

  .inforTitle {
    border-bottom: 1px solid #c0c0c0;
    font-weight: 400;
    color: #2B9AEA;
    font-family: fangsong;
  }

  .addSendCoupon {
    width: 100%;
    height: 40px;
    margin-top: 10px;
    line-height: 40px;
    text-align: center;
    border: 1px dashed #c0c0c0;
    font-size: 15px;
    font-family: 'Microsoft YaHei UI', 'Microsoft YaHei', DengXian, SimSun, 'Segoe UI', Tahoma, Helvetica, sans-serif;
    cursor: pointer;
    letter-spacing: 1px;
  }
</style>